import { get, post, axiosInstance } from "@/utils/api";

import type {
  CreationProps,
  UserInfoProps,
  ServerItem,
  AwardItem,
  RoleItem,
  SecretCodeServerItemProps,
} from "@/pages/Home/index.d";
import type { ApiResponse } from "@/utils/api";

const getCreationList = (): Promise<
  ApiResponse<{
    creation_list: CreationProps[];
  }>
> => {
  return get("/api/vote/creations", { activity_code: "cover_vote" });
};

// 获取个人信息
const getUserInfo = (): Promise<ApiResponse<{ vote_info: UserInfoProps }>> => {
  return get("/api/vote/account/info", { activity_code: "cover_vote" });
};

// 投票
const voteCreation = (id: number): Promise<ApiResponse<void>> => {
  return post("/api/vote/creation", {
    activity_code: "cover_vote",
    creation_id: id,
    vote_count: 1,
  });
};
// 获取服务器列表
const getServerList = (): Promise<ApiResponse<{ list: ServerItem[] }>> => {
  return get("/api/game/server-list");
};

// 认证账号获得token和账号信息
const bindGameRole = (
  serverId: number,
  roleId: number,
  zenyCount: number
): Promise<
  ApiResponse<{
    account_info: any;
    token: string;
  }>
> => {
  return post("/api/account/currency-login ", {
    partition: serverId,
    role_id: roleId,
    currency_count: zenyCount,
  });
};

// 加入社群
const joinCommunity = (type: number): Promise<ApiResponse<void>> => {
  return post("/api/invitation/join-community", {
    activity_code: "cover_vote",
    community_type: type,
  });
};

// 获取分享码
const getShareCode = (): Promise<ApiResponse<{ code: string }>> => {
  return get("/api/reservation/share-code", {
    activity_code: "cover_vote",
  });
};

// 提交分享码
const submitShareCode = (code: string): Promise<ApiResponse<void>> => {
  return post("/api/reservation/share-code", {
    activity_code: "cover_vote",
    share_code: code,
  });
};

// 查询奖励
const queryAward = (): Promise<ApiResponse<{ award_records: AwardItem[] }>> => {
  return get("/api/account/award-records", {
    activity_codes: ["cover_vote"],
  });
};
// 查询角色列表
const queryRoleList = (
  secret_code: string,
  server_id: string
): Promise<ApiResponse<{ list: RoleItem[] }>> => {
  return get("/api/store/game/server/roles", {
    open_id: secret_code,
    server_id,
  });
};

// 校验神秘代码
const verifySecretCode = (
  secret_code: string
): Promise<ApiResponse<{ exist: boolean }>> => {
  return post("/api/store/game/account/verify", {
    open_id: secret_code,
  });
};

// 神秘代码登录下的服务器列表
const secretCodeServerList = (): Promise<
  ApiResponse<{ list: SecretCodeServerItemProps[] }>
> => {
  return get("/api/store/game/servers");
};
// 神秘代码登录
const secretCodeLogin = (
  secret_code: string,
  server_id: string,
  role_id: string
): Promise<ApiResponse<{ account_info: any; token: string }>> => {
  return post("/api/account/code-login", {
    open_id: secret_code,
    server_id,
    role_id,
  });
};

export default {
  voteCreation,
  getUserInfo,
  getCreationList,
  getServerList,
  bindGameRole,
  joinCommunity,
  getShareCode,
  submitShareCode,
  queryAward,
  queryRoleList,
  verifySecretCode,
  secretCodeServerList,
  secretCodeLogin,
};
